import React, { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import {
  Form,
  FormHeader,
  GelContentColumn,
  GelContentContainer,
  GelContentRow,
  TextfieldElement,
  TextareaElement,
  HeroBlock,
  ButtonSecondary,
  Notice,
  Notices,
  FlashState,
  Controls,
  withAuthentication,
  FormErrorSummary,
  withRouter,
  Button,
} from "cw-styleguide-react";

import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { route } from "../../../../routes";
import { Helmet } from "react-helmet";
import { Navigate } from "react-router-dom";
import {
  ACTION_PUBLISH,
  ACTION_SAVE,
  TRANSLATOR_UNASSIGNED,
} from "../../../../constants";
import withAssets from "../../../../components/hoc/withAssets";
import moment from "moment";
import NavigateWithSearch from "../../../../components/NavigateWithSearch";

class VenuesTranslateAmendedView extends Component {
  render() {
    if (this.props.redirect) {
      FlashState.set("flashMessages", this.props.messages);
      return <NavigateWithSearch path={this.props.redirect} />;
    }

    return (
      <Fragment>
        <Helmet>
          <title>{this.props.t("view.venues.translateAmended.title")}</title>
        </Helmet>

        <BreadcrumbsItem
          to={
            route("venuesTranslateManage") +
            route("venuesTranslateAmended", { venue: this.props.values.id })
          }
        >
          {this.props.t("view.venues.translateAmended.breadcrumb")}
        </BreadcrumbsItem>

        <GelContentContainer>
          <h1>{this.props.t("local:view.venues.translateAmended.title")}</h1>
        </GelContentContainer>

        <HeroBlock>
          <p>
            {this.props.t("local:view.venues.translateAmended.introduction")}
          </p>
        </HeroBlock>

        <GelContentContainer>
          {this.props.status && (
            <p>
              <strong>
                {this.props.t(
                  "local:view.courses.edit.field.currentStatus.label"
                )}
              </strong>
              : {this.props.courses.getStatusName(this.props.status)}
            </p>
          )}
          {this.props.audit && this.props.audit.createdBy && (
            <p>
              <strong>
                {this.props.t("local:view.courses.edit.field.createdBy.label")}
              </strong>
              : {this.props.audit.createdBy.name}{" "}
              {moment(this.props.audit.dateCreated).format(
                "DD/MM/YYYY HH:mm:ss"
              )}
            </p>
          )}
          {this.props.audit && this.props.audit.updatedBy && (
            <p>
              <strong>
                {this.props.t("local:view.courses.edit.field.updatedBy.label")}
              </strong>
              : {this.props.audit.updatedBy.name}{" "}
              {moment(this.props.audit.dateUpdated).format(
                "DD/MM/YYYY HH:mm:ss"
              )}
            </p>
          )}
          {this.props.qaDate && (
            <p>
              <strong>
                {this.props.t("local:view.courses.edit.field.qaDate.label")}
              </strong>
              : {moment(this.props.qaDate).format("DD/MM/YYYY HH:mm:ss")}
            </p>
          )}
        </GelContentContainer>

        <GelContentContainer>
          <Controls>
            <ButtonSecondary
              url={route("venuesTranslateManage") + this.props.query}
              title={this.props.t("styleguide:forms.cancel")}
            >
              {this.props.t("styleguide:forms.cancel")}
            </ButtonSecondary>
            <ButtonSecondary
              onClick={() => {
                this.props.saveVenue(
                  this.props.getSaveState(this.props.values.status, ACTION_SAVE)
                );
              }}
              title={this.props.t(
                "local:view.venues.translateAmended.controls.save"
              )}
            >
              {this.props.t("local:view.venues.translateAmended.controls.save")}
            </ButtonSecondary>
            <ButtonSecondary
              onClick={() => {
                this.props.saveVenue(
                  this.props.getSaveState(
                    this.props.values.status,
                    ACTION_PUBLISH
                  )
                );
              }}
              title={this.props.t(
                "local:view.venues.translateAmended.controls.publish"
              )}
            >
              {this.props.t(
                "local:view.venues.translateAmended.controls.publish"
              )}
            </ButtonSecondary>

            {/* Only displays if the Venue has not been assigned to a translator */}
            {this.props.values["translatorAssigned"] ===
              TRANSLATOR_UNASSIGNED && (
              <ButtonSecondary
                onClick={() => {
                  this.props.toggleModal(["assign"], true);
                }}
                title={this.props.t(
                  "local:view.venues.translateDraft.controls.assignToMe"
                )}
              >
                {this.props.t(
                  "local:view.venues.translateDraft.controls.assignToMe"
                )}
              </ButtonSecondary>
            )}
            {/* only displays if a venue has been assigned to a translator and the logged in user has the role Courses_TranslatorManager */}
            {this.props.values["translatorAssigned"] !==
              TRANSLATOR_UNASSIGNED &&
              this.props.authentication.hasRole(
                "Courses_TranslatorManager"
              ) && (
                <ButtonSecondary
                  onClick={() => {
                    this.props.toggleModal(["unassign"], true);
                  }}
                  title={this.props.t(
                    "local:view.venues.translateDraft.controls.reassign"
                  )}
                >
                  {this.props.t(
                    "local:view.venues.translateDraft.controls.reassign"
                  )}
                </ButtonSecondary>
              )}
            <ButtonSecondary
              onClick={this.props.translateVenueAll}
              title={this.props.t(
                "local:view.venues.translateDraft.controls.translateAll"
              )}
            >
              {this.props.t(
                "local:view.venues.translateDraft.controls.translateAll"
              )}
            </ButtonSecondary>
          </Controls>
        </GelContentContainer>

        <GelContentContainer>
          <Notices messages={this.props.messages} />

          {/* Show the error summary */}
          <FormErrorSummary errors={this.props.formErrors} />
        </GelContentContainer>

        <GelContentContainer>
          <h2>{this.props.values["venueName_en"]}</h2>
        </GelContentContainer>

        <GelContentContainer>
          <Form>
            <FormHeader
              title={this.props.t(
                "local:view.venues.translateAmended.formHeader.title"
              )}
              introduction={this.props.t(
                "local:view.venues.translateAmended.formHeader.introduction"
              )}
            />

            <GelContentRow>
              <GelContentColumn md={6}>
                <h3>{this.props.t("styleguide:languages.english")}</h3>
              </GelContentColumn>
              <GelContentColumn md={6}>
                <h3>{this.props.t("styleguide:languages.welsh")}</h3>
              </GelContentColumn>
            </GelContentRow>

            {/* Venue name */}
            {this.props.originalValues["venueName_en"] && (
              <Fragment>
                {this.props.translatableFields.includes("venueName") && (
                  <Notice type={"migration"}>
                    {this.props.t(
                      "local:view.venues.translateAmended.requiresTranslation"
                    )}
                  </Notice>
                )}
                <GelContentRow>
                  <GelContentColumn md={6}>
                    <TextfieldElement
                      size={"medium"}
                      label={this.props.t(
                        "local:view.venues.create.field.venueName.label"
                      )}
                      id={"venueName_en"}
                      name={"venueName_en"}
                      value={this.props.values["venueName_en"]}
                      onChange={this.props.handleChange}
                      errors={this.props.formErrors["venueName_en"]}
                      onKeyPress={this.context.preventDefaultOnEnter}
                    />
                  </GelContentColumn>
                  <GelContentColumn md={6}>
                    <TextfieldElement
                      size={"medium"}
                      label={this.props.t(
                        "local:view.venues.create.field.venueName.label"
                      )}
                      id={"venueName_cy"}
                      name={"venueName_cy"}
                      value={this.props.values["venueName_cy"]}
                      onChange={this.props.handleChange}
                      errors={this.props.formErrors["venueName_cy"]}
                      onKeyPress={this.context.preventDefaultOnEnter}
                      descriptionAfter={
                        <Button
                          asLink={true}
                          onClick={(event) => {
                            this.props.translateVenueField(event, "venueName");
                          }}
                          title={`${this.props.t(
                            "styleguide:forms.translate"
                          )} ${this.props.t(
                            "local:view.venues.create.field.venueName.label"
                          )}`}
                        >
                          {this.props.t("styleguide:forms.translate")}
                        </Button>
                      }
                    />
                  </GelContentColumn>
                </GelContentRow>
              </Fragment>
            )}

            {/* Address line 1 */}
            {this.props.originalValues["addressLine1_en"] && (
              <Fragment>
                {this.props.translatableFields.includes("addressLine1") && (
                  <Notice type={"migration"}>
                    {this.props.t(
                      "local:view.venues.translateAmended.requiresTranslation"
                    )}
                  </Notice>
                )}
                <GelContentRow>
                  <GelContentColumn md={6}>
                    <TextfieldElement
                      size={"medium"}
                      label={this.props.t(
                        "local:view.venues.create.field.addressLine1.label"
                      )}
                      id={"addressLine1_en"}
                      name={"addressLine1_en"}
                      value={this.props.values["addressLine1_en"]}
                      onChange={this.props.handleChange}
                      onKeyPress={this.context.preventDefaultOnEnter}
                    />
                  </GelContentColumn>
                  <GelContentColumn md={6}>
                    <TextfieldElement
                      size={"medium"}
                      label={this.props.t(
                        "local:view.venues.create.field.addressLine1.label"
                      )}
                      id={"addressLine1_cy"}
                      name={"addressLine1_cy"}
                      value={this.props.values["addressLine1_cy"]}
                      onChange={this.props.handleChange}
                      onKeyPress={this.context.preventDefaultOnEnter}
                      descriptionAfter={
                        <Button
                          asLink={true}
                          onClick={(event) => {
                            this.props.translateVenueField(
                              event,
                              "addressLine1"
                            );
                          }}
                          title={`${this.props.t(
                            "styleguide:forms.translate"
                          )} ${this.props.t(
                            "local:view.venues.create.field.addressLine1.label"
                          )}`}
                        >
                          {this.props.t("styleguide:forms.translate")}
                        </Button>
                      }
                    />
                  </GelContentColumn>
                </GelContentRow>
              </Fragment>
            )}

            {/* Address line 2 */}
            {this.props.originalValues["addressLine2_en"] && (
              <Fragment>
                {this.props.translatableFields.includes("addressLine2") && (
                  <Notice type={"migration"}>
                    {this.props.t(
                      "local:view.venues.translateAmended.requiresTranslation"
                    )}
                  </Notice>
                )}
                <GelContentRow>
                  <GelContentColumn md={6}>
                    <TextfieldElement
                      size={"medium"}
                      label={this.props.t(
                        "local:view.venues.create.field.addressLine2.label"
                      )}
                      id={"addressLine2_en"}
                      name={"addressLine2_en"}
                      value={this.props.values["addressLine2_en"]}
                      onChange={this.props.handleChange}
                      onKeyPress={this.context.preventDefaultOnEnter}
                    />
                  </GelContentColumn>
                  <GelContentColumn md={6}>
                    <TextfieldElement
                      size={"medium"}
                      label={this.props.t(
                        "local:view.venues.create.field.addressLine2.label"
                      )}
                      id={"addressLine2_cy"}
                      name={"addressLine2_cy"}
                      value={this.props.values["addressLine2_cy"]}
                      onChange={this.props.handleChange}
                      onKeyPress={this.context.preventDefaultOnEnter}
                      descriptionAfter={
                        <Button
                          asLink={true}
                          onClick={(event) => {
                            this.props.translateVenueField(
                              event,
                              "addressLine2"
                            );
                          }}
                          title={`${this.props.t(
                            "styleguide:forms.translate"
                          )} ${this.props.t(
                            "local:view.venues.create.field.addressLine2.label"
                          )}`}
                        >
                          {this.props.t("styleguide:forms.translate")}
                        </Button>
                      }
                    />
                  </GelContentColumn>
                </GelContentRow>
              </Fragment>
            )}

            {/* Address line 3 */}
            {this.props.originalValues["addressLine3_en"] && (
              <Fragment>
                {this.props.translatableFields.includes("addressLine3") && (
                  <Notice type={"migration"}>
                    {this.props.t(
                      "local:view.venues.translateAmended.requiresTranslation"
                    )}
                  </Notice>
                )}
                <GelContentRow>
                  <GelContentColumn md={6}>
                    <TextfieldElement
                      size={"medium"}
                      label={this.props.t(
                        "local:view.venues.create.field.addressLine3.label"
                      )}
                      id={"addressLine3_en"}
                      name={"addressLine3_en"}
                      value={this.props.values["addressLine3_en"]}
                      onChange={this.props.handleChange}
                      onKeyPress={this.context.preventDefaultOnEnter}
                    />
                  </GelContentColumn>
                  <GelContentColumn md={6}>
                    <TextfieldElement
                      size={"medium"}
                      label={this.props.t(
                        "local:view.venues.create.field.addressLine3.label"
                      )}
                      id={"addressLine3_cy"}
                      name={"addressLine3_cy"}
                      value={this.props.values["addressLine3_cy"]}
                      onChange={this.props.handleChange}
                      onKeyPress={this.context.preventDefaultOnEnter}
                      descriptionAfter={
                        <Button
                          asLink={true}
                          onClick={(event) => {
                            this.props.translateVenueField(
                              event,
                              "addressLine3"
                            );
                          }}
                          title={`${this.props.t(
                            "styleguide:forms.translate"
                          )} ${this.props.t(
                            "local:view.venues.create.field.addressLine3.label"
                          )}`}
                        >
                          {this.props.t("styleguide:forms.translate")}
                        </Button>
                      }
                    />
                  </GelContentColumn>
                </GelContentRow>
              </Fragment>
            )}

            {/* Address line 4 */}
            {this.props.originalValues["addressLine4_en"] && (
              <Fragment>
                {this.props.translatableFields.includes("addressLine4") && (
                  <Notice type={"migration"}>
                    {this.props.t(
                      "local:view.venues.translateAmended.requiresTranslation"
                    )}
                  </Notice>
                )}
                <GelContentRow>
                  <GelContentColumn md={6}>
                    <TextfieldElement
                      size={"medium"}
                      label={this.props.t(
                        "local:view.venues.create.field.addressLine4.label"
                      )}
                      id={"addressLine4_en"}
                      name={"addressLine4_en"}
                      value={this.props.values["addressLine4_en"]}
                      onChange={this.props.handleChange}
                      onKeyPress={this.context.preventDefaultOnEnter}
                    />
                  </GelContentColumn>
                  <GelContentColumn md={6}>
                    <TextfieldElement
                      size={"medium"}
                      label={this.props.t(
                        "local:view.venues.create.field.addressLine4.label"
                      )}
                      id={"addressLine4_cy"}
                      name={"addressLine4_cy"}
                      value={this.props.values["addressLine4_cy"]}
                      onChange={this.props.handleChange}
                      onKeyPress={this.context.preventDefaultOnEnter}
                      descriptionAfter={
                        <Button
                          asLink={true}
                          onClick={(event) => {
                            this.props.translateVenueField(
                              event,
                              "addressLine4"
                            );
                          }}
                          title={`${this.props.t(
                            "styleguide:forms.translate"
                          )} ${this.props.t(
                            "local:view.venues.create.field.addressLine4.label"
                          )}`}
                        >
                          {this.props.t("styleguide:forms.translate")}
                        </Button>
                      }
                    />
                  </GelContentColumn>
                </GelContentRow>
              </Fragment>
            )}

            {/* Town/City */}
            {this.props.originalValues["townCity_en"] && (
              <Fragment>
                {this.props.translatableFields.includes("townCity") && (
                  <Notice type={"migration"}>
                    {this.props.t(
                      "local:view.venues.translateAmended.requiresTranslation"
                    )}
                  </Notice>
                )}
                <GelContentRow>
                  <GelContentColumn md={6}>
                    <TextfieldElement
                      size={"medium"}
                      label={this.props.t(
                        "local:view.venues.create.field.townCity.label"
                      )}
                      id={"townCity_en"}
                      name={"townCity_en"}
                      value={this.props.values["townCity_en"]}
                      onChange={this.props.handleChange}
                      onKeyPress={this.context.preventDefaultOnEnter}
                    />
                  </GelContentColumn>
                  <GelContentColumn md={6}>
                    <TextfieldElement
                      size={"medium"}
                      label={this.props.t(
                        "local:view.venues.create.field.townCity.label"
                      )}
                      id={"townCity_cy"}
                      name={"townCity_cy"}
                      value={this.props.values["townCity_cy"]}
                      onChange={this.props.handleChange}
                      onKeyPress={this.context.preventDefaultOnEnter}
                      descriptionAfter={
                        <Button
                          asLink={true}
                          onClick={(event) => {
                            this.props.translateVenueField(event, "townCity");
                          }}
                          title={`${this.props.t(
                            "styleguide:forms.translate"
                          )} ${this.props.t(
                            "local:view.venues.create.field.townCity.label"
                          )}`}
                        >
                          {this.props.t("styleguide:forms.translate")}
                        </Button>
                      }
                    />
                  </GelContentColumn>
                </GelContentRow>
              </Fragment>
            )}

            {/* County */}
            {this.props.originalValues["county_en"] && (
              <Fragment>
                {this.props.translatableFields.includes("county") && (
                  <Notice type={"migration"}>
                    {this.props.t(
                      "local:view.venues.translateAmended.requiresTranslation"
                    )}
                  </Notice>
                )}
                <GelContentRow>
                  <GelContentColumn md={6}>
                    <TextfieldElement
                      size={"medium"}
                      label={this.props.t(
                        "local:view.venues.create.field.county.label"
                      )}
                      id={"county_en"}
                      name={"county_en"}
                      value={this.props.values["county_en"]}
                      onChange={this.props.handleChange}
                      onKeyPress={this.context.preventDefaultOnEnter}
                    />
                  </GelContentColumn>
                  <GelContentColumn md={6}>
                    <TextfieldElement
                      size={"medium"}
                      label={this.props.t(
                        "local:view.venues.create.field.county.label"
                      )}
                      id={"county_cy"}
                      name={"county_cy"}
                      value={this.props.values["county_cy"]}
                      onChange={this.props.handleChange}
                      onKeyPress={this.context.preventDefaultOnEnter}
                      descriptionAfter={
                        <Button
                          asLink={true}
                          onClick={(event) => {
                            this.props.translateVenueField(event, "county");
                          }}
                          title={`${this.props.t(
                            "styleguide:forms.translate"
                          )} ${this.props.t(
                            "local:view.venues.create.field.county.label"
                          )}`}
                        >
                          {this.props.t("styleguide:forms.translate")}
                        </Button>
                      }
                    />
                  </GelContentColumn>
                </GelContentRow>
              </Fragment>
            )}

            {/* Extra Facilities */}
            {this.props.originalValues["extraFacilities_en"] && (
              <Fragment>
                {this.props.translatableFields.includes("extraFacilities") && (
                  <Notice type={"migration"}>
                    {this.props.t(
                      "local:view.venues.translateAmended.requiresTranslation"
                    )}
                  </Notice>
                )}
                <GelContentRow>
                  <GelContentColumn md={6}>
                    <TextareaElement
                      size={"medium"}
                      label={this.props.t(
                        "local:view.venues.create.field.extraFacilities.label"
                      )}
                      id={"extraFacilities_en"}
                      name={"extraFacilities_en"}
                      value={this.props.values["extraFacilities_en"]}
                      onChange={this.props.handleChange}
                      onKeyPress={this.context.preventDefaultOnEnter}
                    />
                  </GelContentColumn>
                  <GelContentColumn md={6}>
                    <TextareaElement
                      size={"medium"}
                      label={this.props.t(
                        "local:view.venues.create.field.extraFacilities.label"
                      )}
                      id={"extraFacilities_cy"}
                      name={"extraFacilities_cy"}
                      value={this.props.values["extraFacilities_cy"]}
                      onChange={this.props.handleChange}
                      onKeyPress={this.context.preventDefaultOnEnter}
                      descriptionAfter={
                        <Button
                          asLink={true}
                          onClick={(event) => {
                            this.props.translateVenueField(
                              event,
                              "extraFacilities"
                            );
                          }}
                          title={`${this.props.t(
                            "styleguide:forms.translate"
                          )} ${this.props.t(
                            "local:view.venues.create.field.extraFacilities.label"
                          )}`}
                        >
                          {this.props.t("styleguide:forms.translate")}
                        </Button>
                      }
                    />
                  </GelContentColumn>
                </GelContentRow>
              </Fragment>
            )}

            {/* Hidden fields */}
          </Form>
        </GelContentContainer>
      </Fragment>
    );
  }
}

export default withAssets(
  withRouter(
    withAuthentication(withTranslation("local")(VenuesTranslateAmendedView))
  )
);
